import { Pipe, PipeTransform } from '@angular/core';

import { SessionService } from '../../sessions/session.service';

@Pipe({
  name: 'chargifyCurrency'
})
export class ChargifyCurrencyPipe implements PipeTransform {

  constructor(
    private sessionService: SessionService
  ) {}

  transform( value : string | number ) : string {
    const regexp    = /^[0-9.,]+$/;
    const subdomain = this.sessionService.company().subscription_subdomain;

    if (typeof(value) === 'string' && !regexp.test(value)) {
      return value;
    }

    return subdomain === 'workshop-software-uk'
        || subdomain === 'ari-uk'
        || subdomain === 'workshop-software-eu'
        ? `£${value}`
        : `$${value}`;
  }
}
